module.exports = __webpack_public_path__ + "img/magic.fe0d4f7c.svg";